import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalTechnologyUnauthorizedModel } from './types';
import { legalTechnologyUnauthorizedItemValidator } from './validators/item';

const legalTechnologyUnauthorizedValidator: ValidateJSModel<LegalTechnologyUnauthorizedModel> = {
  HasUnauthorized: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasUnauthorized && attributes?.HasUnauthorized.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyUnauthorizedItemValidator },
      };
    }
    return {};
  },
};
export default legalTechnologyUnauthorizedValidator;
